import api from "@/plugins/api/EntryPoint";

export default {
  getKirovogradEnergoDataForPersonalAccount(callBackFn) {
    return api.get(`kirovograd-personal-account/get-personal-account-data`, callBackFn);
  },
  setKirovogradEnergoDataForPersonalAccount(data, callBackFn) {
    return api.post(`kirovograd-personal-account/set-personal-account-data`, {ls: data.ls, meter_digits: data.meterDigits }, callBackFn);
  },
};
